module.exports = __webpack_public_path__ + "img/cavalier-challenge-2-mobile_cc8f143afdb2e3156c9e5e0f246939e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/cavalier-challenge-2-mobile.jpg
// module id = 268
// module chunks = 0